const policyStatement = [
  '株式会社MSKは人に必要とされる人を創ります。',
  'そして社会から必要とされる会社に成ります。',
  'それは社会貢献すると同時に私達の存在意義となり、',
  '社会を豊かにすることだと確信しています。',
];

const mottoItems = [
  '最も重要な事から始めなさい',
  '行なわなければならない事をしっかり行いなさい',
  '出来ないことではなく出来ることに集中しなさい',
  '仕事のやり方ではなく仕事の意味を考えなさい',
  '挑戦には間違いや失敗を許す余地がなければならない、失敗を恐れず色々なことに挑戦しなさい',
  '正しい判断を多く出来る人ではなく、誤った判断を素早く見つけ認め改めることの出来る人になりなさい',
  '仕事を楽しみなさい',
];

const PolicyContent = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* 経営方針 */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-compass-3-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              経営方針
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-10 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <h3 className="text-lg md:text-xl font-bold text-[#89B56B] mb-6 leading-relaxed">
              人に必要とされる人を創る
            </h3>
            <div className="space-y-2">
              {policyStatement.map((line, index) => (
                <p
                  key={index}
                  className="text-[13px] md:text-sm text-gray-700 leading-[1.9] pl-4 border-l-2 border-[#89B56B]/20"
                >
                  {line}
                </p>
              ))}
            </div>
          </div>
        </div>

        {/* 社訓 */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-quill-pen-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              社訓
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-10 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <ul className="space-y-5">
              {mottoItems.map((item, index) => (
                <li key={index} className="flex items-start gap-4 group">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-[#89B56B]/10 text-[#5DAA68] text-xs font-bold mt-0.5 group-hover:bg-[#5DAA68] group-hover:text-white transition-colors">
                    {index + 1}
                  </span>
                  <p className="text-[13px] md:text-sm text-gray-700 leading-[1.9] pt-0.5">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PolicyContent;
